/* Livello di autorizzazione dell'utente. Valore:
true | false
*/
import { createContext } from "react";
const isAdminContext = createContext({
    isAdmin: false,
    setIsAdmin: (admin) => {}
  });
export default isAdminContext;